jQuery('document').ready(function ($) {
    if ($('.category').length > 0) {
        var filters = [];
        var filtersApplications = [];
        var filtersMarches = [];
        var filtersList_1 = [];
        filtersList_1['offre'] = ['*'];
        filtersList_1['marches'] = ['*'];
        var filterBox = $('.filters');
        /**
         * Initiating Isotop
         */
        var $grid_1 = $('.category_content').isotope({
            itemSelector: '.category_content_item',
            // From below ?
            layoutMode: 'masonry',
            hiddenStyle: {
                opacity: 0
            },
            visibleStyle: {
                opacity: 1
            }
        });
        /**
         * Initiating the container
         */
        // $('.category_content').isotope({
        // layoutMode: 'masonry',
        // });
        /**
         * Retrieving all filters
         */
        // $('.filters_applications .filters_item').each((key, elem) => {
        //     let catFilters = $(elem).data('filter');
        //     filtersApplications.push(catFilters);
        // });
        // $('.filters_marches .filters_item').each((key, elem) => {
        //     let catFilters = $(elem).data('filter');
        //     filtersMarches.push(catFilters);
        // });
        // console.log(filtersApplications, filtersMarches);
        /**
         * Event listener for filter selection
         */
        filterBox.on('click', '.filters_item', function () {
            var filterValue = $(this).attr('data-filter');
            var filterList = $(this).attr('data-list');
            for (var key in filtersList_1) {
                if (filtersList_1.hasOwnProperty(key) && filterList == key) {
                    var element = filtersList_1[key];
                    var index = element.indexOf(filterValue);
                    if (filterValue == '*') {
                        // Clicked on ALL filter, we remove everything
                        element.splice(0, element.length);
                        element.push('*');
                        $('.filters_' + key + ' .filters_item').removeClass('active');
                        $('.filters_' + key + ' .filters_item.all').addClass('active');
                    }
                    else {
                        if (index < 0) {
                            // ENABLE A FILTER
                            if (element.length == 1 && element[0] == '*') {
                                element.splice(0, 1);
                            }
                            element.push(filterValue);
                            $(this).addClass('active');
                            $('.filters_' + key + ' .filters_item.all').removeClass('active');
                        }
                        else {
                            // DISABLE A FILTER
                            element.splice(index, 1);
                            $(this).removeClass('active');
                            // We check if all filters have been removed, in which case we activate * filter
                            if (element.length == 0) {
                                element.push('*');
                                // filters.push('*');
                                $('.filters_' + key + ' .filters_item').removeClass('active');
                                $('.filters_' + key + ' .filters_item.all').addClass('active');
                                // $('.filters_item.all').addClass('active');
                            }
                        }
                    }
                }
            }
            // console.log(filtersList);
            $grid_1.isotope({
                filter: function () {
                    // console.log('new product ___');
                    var category = $(this).data('category').split(' ');
                    var isInLastFilter = true;
                    var isInFilter = false;
                    var _loop_1 = function (key) {
                        if (filtersList_1.hasOwnProperty(key)) {
                            var element_1 = filtersList_1[key];
                            // let isInFilter: boolean = false;
                            if (isInLastFilter) {
                                // console.log(element, category);
                                isInFilter = false;
                                if (element_1.length == 1 && element_1[0] == '*') {
                                    isInFilter = true;
                                }
                                else {
                                    category.forEach(function (elem) {
                                        if (!isInFilter) {
                                            isInFilter = element_1.indexOf(elem) >= 0;
                                        }
                                        // console.log(element.indexOf(elem));
                                    });
                                }
                                isInLastFilter = isInFilter;
                                // console.log(isInLastFilter);
                            }
                        }
                    };
                    for (var key in filtersList_1) {
                        _loop_1(key);
                    }
                    return isInFilter;
                }
            });
        });
    }
});
